import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Subject, Observable } from 'rxjs';
import { Upgrade } from 'src/app/_models/upgrade';
import { HttpClient, HttpParams } from '@angular/common/http';
import { UpgradeView } from 'src/app/_models/upgradeView';
import { UpgradeCorrection } from 'src/app/_models/upgradeCorrection';

@Injectable({
   providedIn: 'root',
})
export class UpgradeService {
   baseUrl = environment.apiUrl;
   ImportSelected = new Subject<Upgrade>();
   upgradeSelected = new Subject<Upgrade>();
   isTemplateOnly = true;

   constructor(private http: HttpClient) {}

   changeEditState(u: Upgrade) {
      this.upgradeSelected.next(u);
   }

   changeImportState(upgrade: Upgrade) {
      this.ImportSelected.next(upgrade);
   }

   getUpgrade(id): Observable<Upgrade> {
      return this.http.get<Upgrade>(this.baseUrl + 'upgrade/' + id);
   }
   getUpgradeView(id): Observable<UpgradeView> {
      return this.http.get<UpgradeView>(this.baseUrl + 'upgrade/view/' + id);
   }
   getUpgradeViewJournalRef(id): Observable<UpgradeView> {
      return this.http.get<UpgradeView>(this.baseUrl + 'upgrade/view/journalref/' + id);
   }
   getUpgradeCorrection(id): Observable<UpgradeCorrection> {
      return this.http.get<UpgradeCorrection>(this.baseUrl + 'upgrade/correction/' + id);
   }
   getUpgradeCorrectionJournalRef(id): Observable<UpgradeCorrection> {
      return this.http.get<UpgradeCorrection>(this.baseUrl + 'upgrade/correction/journalref/' + id);
   }
   createUpgrade(upgrade: Upgrade) {
      return this.http.post(this.baseUrl + 'upgrade', upgrade);
   }
   updateUpgrade(id: number, upgrade: Upgrade) {
      return this.http.put(this.baseUrl + 'upgrade/' + id, upgrade);
   }
   cancelUpgrade(id: number) {
      return this.http.delete(this.baseUrl + 'upgrade/cancel/' + id);
   }
   cancelBulk(ids: number[]) {
      let params = new HttpParams();
      ids.forEach((id) => {
         params = params.append('ids', id.toString());
      });
      return this.http.delete(this.baseUrl + 'upgrade/cancel?' + params.toString());
   }
   remove(date: string, type: string) {
      if (type == 'transaction') {
         return this.http.post(this.baseUrl + 'upgrade/removeByTransactionDate/' + date, '');
      } else {
         return this.http.post(this.baseUrl + 'upgrade/removeByCaptureDate/' + date, '');
      }
   }
   removeById(id: number) {
      return this.http.delete(this.baseUrl + 'upgrade/removebyid/' + id);
   }

   exportForCorrection(): Observable<Blob> {
      // tslint:disable-next-line:max-line-length
      return this.http.get(this.baseUrl + 'upgrade/exportForCorrection/true', {
         responseType: 'blob',
      });
   }

   exportForRemoval(): Observable<Blob> {
      return this.http.get(this.baseUrl + 'upgrade/exportForRemoval', {
         responseType: 'blob',
      });
   }

   exportForCancellation(): Observable<Blob> {
      return this.http.get(this.baseUrl + 'upgrade/exportForCancellation', {
         responseType: 'blob',
      });
   }
   
   exportCorrections(): Observable<Blob> {
      // tslint:disable-next-line:max-line-length
      return this.http.get(this.baseUrl + 'upgrade/exportcorrections', {
         responseType: 'blob',
      });
   }

   getHasWorkflow(): Observable<boolean> {
     return this.http.get<boolean>(this.baseUrl + 'upgrade/hasWorkflow');
   }
}
